import Swal from 'sweetalert2';

const isDark = () => document.documentElement.classList.contains('dark');
const bg = () => (isDark() ? '#1a1a1a' : '#fff');
const color = () => (isDark() ? '#f0fdf0' : '#1a2e1a');

// Styling global swal2 dipasang sekali lewat CSS (lihat index.css .swal2-*),
// wrapper ini mereplikasi API window.Swal2 dari project PHP asli 1:1.
export const Swal2 = {
  toast(type, message) {
    return Swal.fire({
      toast: true,
      position: 'top-end',
      icon: type,
      title: message,
      showConfirmButton: false,
      timer: 3500,
      timerProgressBar: true,
      background: bg(),
      color: color(),
      didOpen: (toastEl) => {
        toastEl.addEventListener('mouseenter', Swal.stopTimer);
        toastEl.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });
  },

  success(title, html) {
    return Swal.fire({
      icon: 'success',
      title,
      html,
      confirmButtonText: 'Oke, Terima Kasih!',
      background: bg(),
      color: color(),
    });
  },

  async confirmDelete(nama = 'data ini') {
    const result = await Swal.fire({
      title: 'Hapus Data?',
      html: `Data <strong>${nama}</strong> akan dihapus permanen dan tidak bisa dikembalikan.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '<span class="material-symbols-outlined" style="vertical-align:middle;font-size:18px;">delete</span> Ya, Hapus!',
      cancelButtonText: 'Batal',
      reverseButtons: true,
      focusCancel: true,
      background: bg(),
      color: color(),
    });
    return result.isConfirmed;
  },

  async confirm(title, html, confirmText, type = 'question') {
    const result = await Swal.fire({
      title,
      html,
      icon: type,
      showCancelButton: true,
      confirmButtonText: confirmText,
      cancelButtonText: 'Batal',
      reverseButtons: true,
      background: bg(),
      color: color(),
    });
    return result.isConfirmed;
  },
};
